module.exports = __webpack_public_path__ + "static/media/noData.1f9c7391.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/search/noData.svg
// module id = 1995
// module chunks = 1